import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUpdateNextActionMutation } from "../store/services/nextActionService";
import { WorkItemList } from "../store/services/timelineApiRTK";
import {
  useSetWorkItemFavoriteMutation,
  WorkItemFavoriteTypeEnum,
} from "../store/services/workItemService";

export const useActivityDialog = (
  activity: WorkItemList,
  onClose: () => void
) => {
  const navigate = useNavigate();
  const [showWork, setShowWork] = useState(false);
  const [showCompleteDialog, setShowCompleteDialog] = useState(false);
  const [showMoveDialog, setShowMoveDialog] = useState(false);
  const [showAssignDialog, setShowAssignDialog] = useState(false);

  const [setFavorite] = useSetWorkItemFavoriteMutation();
  const [updateWorkItem] = useUpdateNextActionMutation();

  const handleCustomerClick = () => {
    if (activity.Customer?.Id) {
      navigate(`/customer/${activity.Customer.Id}`, {
        replace: true,
      });
    }
  };

  const handleFinishClicked = () => {
    setShowCompleteDialog(true);
  };

  const handleClose = () => {
    setShowCompleteDialog(false);
    setShowMoveDialog(false);
    setShowWork(false);
    setShowAssignDialog(false);
    onClose();
  };

  const handleToggleFavorite = () => {
    if (!activity?.Id) {
      console.error("Cannot toggle favorite without a valid activity ID");
      return;
    }
    setFavorite({
      workItemId: activity.Id,
      type:
        activity.FavoriteType === WorkItemFavoriteTypeEnum.Favorite
          ? WorkItemFavoriteTypeEnum.NotSet
          : WorkItemFavoriteTypeEnum.Favorite,
    });
  };

  const handleUpdateDescription = async (newDescription: string) => {
    if (!activity) {
      throw new Error("Ingen aktivitet hittades");
    }

    try {
      await updateWorkItem({
        customerNo: activity.Customer.Id,
        request: {
          scheduledDate: activity.ScheduledTo,
          title: activity.Name,
          description: newDescription,
          teamId: activity.Team?.Id,
          assignedToId: activity.AssignedTo?.Id,
          externalId: activity.ExternalId,
          workNo: activity.WorkId ?? undefined,
          type: activity.Type,
          workItemNo: activity.Id,
        },
      }).unwrap();
    } catch (error) {
      console.error("Error updating description:", error);
      throw error;
    }
  };

  return {
    showWork,
    setShowWork,
    showCompleteDialog,
    setShowCompleteDialog,
    showMoveDialog,
    setShowMoveDialog,
    showAssignDialog,
    setShowAssignDialog,
    handleCustomerClick,
    handleFinishClicked,
    handleClose,
    handleToggleFavorite,
    handleUpdateDescription,
  };
};
